// type test =

export function sort<Type>(
  data: Type[],
  keyset: keyof Type,
  direction: "accending" | "decending"
): Type[] {
  return data.sort((a, b) => {
    const dataA = a[keyset] || 0;
    const dataB = b[keyset] || 0;

    if (dataA < dataB) {
      return direction === "accending" ? -1 : 1;
    }

    return direction === "accending" ? 1 : -1;
  });
}
